import React from 'react'
import { ButtonBase } from '@material-ui/core'
import { inject, observer } from 'mobx-react'

@inject('experience')
@observer
class TargetFoundCta extends React.Component {
  state = {
    id: '',
  }
  close = () => {
    this.props.experience.toggleModal(false)
  }
  componentDidMount () {
    let newId = ''
    
    if (this.props.id === 'racing') {
      newId = 'internet'
    }
    if (this.props.id === 'basketball') {
      newId = 'unlimitied'
    }
    if (this.props.id === 'football') {
      newId = 'prepaid'
    }

    this.setState({id: newId})
  }

  render = () => (
    <div className={`target-found ${this.props.target ? 'slide-in' : ''}`}>
      <div className='simple-close' onClick={this.close}></div>
      <div className='content'>
        <h1>Score!</h1>
        <p>You found a target.</p>
        <ButtonBase id={this.state.id} className='button' onClick={() => {
          this.props.click()
        }}>
          Open Now
        </ButtonBase>
      </div>
    </div>
  )
}

export default TargetFoundCta
